import FindUpdates from './FindUpdates';

export default FindUpdates;
